import React from 'react'
import { connect } from 'react-redux'
import Cable from 'actioncable'

import { ajaxDelete, ajaxPost } from '../../ajax'
import Cart from './cart'
import ButtonsBar from '../../components/buttons-bar'
import { ShopProductList as ProductList } from './product-list'
import BraintreePaymentModal from '../../components/braintree-payment-modal'
import StripePaymentModal from '../../components/stripe-payment-modal'
import StripeTerminalModal from '../../components/stripe-terminal-modal'
import StripeReadersModal from '../../components/stripe-readers-modal'
import StripeM2Modal from '../../components/stripe-m2-modal'
import StripeTerminalConnect from '../../components/stripe-terminal-connect'
import StripeM2Connect from '../../components/stripe-m2-connect'
import SelectPaymentModal from '../../components/select-payment-modal'
import ReservationModal from './reservation-modal'
import OpenOrdersButton from './open-orders-button'
import OpenOrderTitle from './open-order-title'
import OpenOrderQRCode from './open-order-qr-code'
import { calculateCart } from '../../shop/common'
import FlashMessage from '../flash-message'
import Signature from '../../components/signature'

const selectPaymentModalStyle = props =>
  props.openOrders.isNameModalOpen ? {overlay: {backgroundColor: 'transparent'}} : {}

class Shop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showManualCardPayment: false,
      showTerminalModal: false,
      showM2Modal: false,
      showStripeReadersModal: false,
      isScrolling: false,
      currentShopIndex: 0,
      terminal: null,
      readers: [],
      connectedReader: null,
      stripeLoading: false
    }
    this.onChangeShop = index => {
      const newShop = this.props.shopList[index]
      this.props.dispatch({
        type: 'SHOP_CHANGE', 
        id: newShop.id,
        shopType: this.props.entity.shopType,
        location: newShop.location,
        stripeLocation: newShop.stripe_location,
        currency: newShop.currency,
        account: newShop.account,
      })
      this.setState({currentShopIndex: index})
    }
    this.handleManualCardPayment = this.handleManualCardPayment.bind(this)
    this.handlePaymentTypeSelection = this.handlePaymentTypeSelection.bind(this)
    this.closeModals = this.closeModals.bind(this)
  }

  componentWillMount() {
    this.createSocket()
  }

  deletePaidOrder() {
    let orderId = this.props.openOrders.currentId
    ajaxDelete(`/admins/orders/${orderId}`)
    this.props.dispatch({ type: 'OPEN_ORDER.CLEAR_CURRENT' })
    this.props.dispatch({ type: 'ENTITIES.DELETE', payload: { type: 'openOrders', id: orderId } })
  }

  handleTouchlessPaymentSuccess(data) {
    this.deletePaidOrder()
    this.props.dispatch({ type: 'ORDER.TOUCHLESS_ORDER_CLOSED' })
    this.props.dispatch({ type: 'TOUCHLESS_PAYMENT_SUCCESS', payload: data })
    setTimeout(this.clearFlash, 2500, this.props.dispatch)
    this.props.dispatch({ type: 'OPEN_ORDER.CLOSE_TITLE' })
  }

  clearFlash = dispatch => dispatch({type: 'FLASH_CLEAR'})

  createSocket() {
    let cable = Cable.createConsumer(this.props.entity.socketUrl)
    this.chats = cable.subscriptions.create({
      channel: 'PaymentsChannel',
      location_id: this.props.entity.locationId
    }, {
      received: (data) => {
        if (data.message.order_id == this.props.openOrders.currentId) {
          this.handleTouchlessPaymentSuccess(data)
        }
      }
    })
  }

  handlePaymentTypeSelection(paymentType) {
    switch(paymentType) {
      case 'MANUAL_CARD':
        this.setState({showManualCardPayment: true})
        break
      case 'CASH':
        this.closeModals()
        this.props.dispatch({type: 'PAY_VIA_CASH', payload: {type: 'cash'}})
        break
      case 'ZELLE':
        this.closeModals()
        this.props.dispatch({type: 'PAY_VIA_ZELLE', payload: {type: 'zelle'}})
        break
      case 'TOUCHLESS':
        this.closeModals()
        this.props.dispatch({type: 'PAY_TOUCHLESS'})
        break
      case 'TERMINAL':
        this.setState({showTerminalModal: true})
        break
      case 'M2_TERMINAL':
        this.setState({showM2Modal: true})
        break
    }
  }

  handleManualCardPayment(paymentMethod) {
    this.props.dispatch({type: 'CARD_NUMBER_PAYMENT_METHOD_RECEIVED', payload: paymentMethod})
    this.setState({showManualCardPayment: false, showTerminalModal: false, showM2Modal: false})
  }

  closeModals() {
    this.props.dispatch({type: 'PAYMENT_MODAL_CLOSED'})
    this.setState({showManualCardPayment: false, showTerminalModal: false, showM2Modal: false})
  }

  m2ConnectButtonClass() {
    const entity = this.props.entity
    const classes = ['stripe-terminal-icon', 'm2']
    if (!entity.stripe.location) classes.push('disabled')
    if (!entity.stripe.m2Connected) classes.push('inactive')
    return classes.join(' ')
  }

  onShowM2Readers() {
    const entity = this.props.entity
    if (!entity.stripe.location) return

    this.props.onM2Readers()
  }

  render() {
    const { amountWithoutTax, totalAmount, appFee, appFeeInPrice } = calculateCart(this.props.cart, this.props.products)
    const entity = this.props.entity
    const isShop = entity.shopType == 'PointOfSale'
    const stripe = entity.stripe
    const allowM2 = !!stripe && stripe.allow_m2 && !!window.webkit
    const currencyName = entity.currency == 'usd' ? '' : ` (${entity.currency.toUpperCase()})`

    return (
      <div className='row'>
        { !!stripe && 
          <StripeTerminalConnect
            stripe={stripe}
            location={entity.locationId}
            terminal={this.state.terminal}
            readers={this.state.readers}
            connectedReader={this.state.connectedReader}
            onTerminalSet={(value) => this.setState({terminal: value})}
            onReadersFetch={(value) => this.setState({readers: value})}
            onReaderConnect={(value) => this.setState({connectedReader: value})}
            onError={(value) => console.log('STRIPE ERROR: ', value)}
            onLoading={(value) => this.setState({stripeLoading: value})}
          />
        }
        { allowM2 && 
          <StripeM2Connect
            stripe={stripe}
            location={entity.locationId}
            initConnection={this.props.onM2Connection}
          />
        }
        <FlashMessage />
        <div className='col-sm-8'>
          <OpenOrderTitle />
          <ButtonsBar items={this.props.shopList} selected={this.state.currentShopIndex}
            onClick={this.onChangeShop} className='shop-inventory__buttons' />
          <ProductList
            filter={this.state.searchText}
            hasReservation={isShop}
            currency={entity.currency}
          />
        </div>
        <div className='col-sm-4'>
          <Cart
            buttonText={`Charge${currencyName}`}
            showDiscountPerItem={entity.showDiscountPerItem}
            onClickButton={this.props.onClickCharge} 
          />
          <OpenOrdersButton />
        </div>
        <SelectPaymentModal isOpen={this.props.payment.isSelectorOpen}
          cardAmount={totalAmount}
          cashAmount={amountWithoutTax}
          onRequestClose={this.closeModals}
          onClickOpenOrder={this.props.onClickOpenOrder}
          onPaymentTypeSelected={this.handlePaymentTypeSelection}
          showTouchless={entity.showTouchless}
          zellePayments={entity.zellePayments}
          showTerminal={!!stripe}
          showM2={allowM2}
          style={selectPaymentModalStyle(this.props)} 
        />
        { !stripe && 
          <BraintreePaymentModal isOpen={this.state.showManualCardPayment}
            amount={totalAmount}
            onRequestClose={this.closeModals}
            onPaymentMethodReceived={this.handleManualCardPayment} 
          />
        }
        { !!stripe && this.state.showManualCardPayment && 
          <StripePaymentModal
            currency={entity.currency}
            amount={totalAmount}
            appFee={appFee + appFeeInPrice}
            stripe={stripe}
            location={entity.locationId}
            onClose={this.closeModals}
            onPayment={this.handleManualCardPayment}
          />
        }
        { this.state.showTerminalModal && 
          <StripeTerminalModal
            terminal={this.state.terminal}
            reader={this.state.connectedReader}
            currency={entity.currency}
            amount={totalAmount}
            appFee={appFee + appFeeInPrice}
            location={entity.locationId}
            onClose={() => this.setState({showTerminalModal: false}) }
            onPayment={this.handleManualCardPayment}
          />
        }
        { this.state.showM2Modal &&
          <StripeM2Modal
            connected={stripe.m2Connected}
            currency={entity.currency}
            amount={totalAmount}
            appFee={appFee + appFeeInPrice}
            location={entity.locationId}
            onClose={() => this.setState({showM2Modal: false})}
            onPayment={this.props.onM2Payment}
          />
        }
        <OpenOrderQRCode />
        <ReservationModal checkScroll={this.checkScroll} />
        { !!stripe && 
          <div 
            className={'stripe-terminal-icon' + (this.state.connectedReader ? '' : ' inactive')}
            onClick={() => this.setState({showStripeReadersModal: true})}
          >
          </div>
        }
        { allowM2 && <div className={this.m2ConnectButtonClass()} onClick={this.onShowM2Readers.bind(this)}></div> }
        { this.state.showStripeReadersModal && 
          <StripeReadersModal 
            terminal={this.state.terminal}
            readers={this.state.readers}
            connectedReader={this.state.connectedReader}
            stripeLoading={this.state.stripeLoading}
            onClose={() => this.setState({showStripeReadersModal: false})}
            onConnect={(reader) => this.setState({connectedReader: reader})}
          />
        }
        { this.props.payment.signature && 
          <Signature
            {...this.props.payment.signature}
            onComplete={this.props.completeSignature}
            onClose={this.props.stopSignature}
            onSendReceipt={this.props.onSendReceipt}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...state.currentShop,
  shopList: state.shopList.items,
  products: state.entities.products
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  onClickCharge: () => dispatch({type: 'SHOP.CHARGE'}),
  onClickOpenOrder: () => dispatch({type: 'PAYMENT_TYPE.OPEN_ORDER_CLICKED'}),
  onM2Connection: (payload) => dispatch({type: 'M2.CONNECTION', payload}),
  onM2Readers: () => dispatch({type: 'M2.READERS'}),
  onM2Payment: (payload) => dispatch({type: 'M2.PAYMENT', payload}),
  stopSignature: () => dispatch({type: 'SIGNATURE.STOP'}),
  completeSignature: payload => dispatch({type: 'SIGNATURE.COMPLETE', payload}),
  onSendReceipt: payload => dispatch({type: 'SEND_RECEIPT', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Shop)
